<div [formGroup]="frmGroup" fxFlex>
    <!-- <div>{{configData.label}}</div> -->
    <div [formArrayName]="configData.name" fxFlex class="mat-table mat-elevation-z0">
        <div *ngIf="allowedLine">
            <div *ngFor="let row of getFormTableControls(); let rowIndex = index" class="row mat-row" [ngClass]="{odd: rowIndex % 2 === 2}"
                style="margin:0px; padding-left: 16px">
                <div *ngIf="configData.lineNumber" class="mat-cell" fxFlex="0 0 30px">{{rowIndex+1}}</div>
                <div fxFlex="calc(100%-85px)">
                    <div class="row">
                        <div *ngFor="let control of configData.controls" [formGroupName]="rowIndex" class="col mat-cell" [ngClass]="getColsClass(control.cols)">
                            <app-form-field [ngClass]="{'add-padding': frmGroup.controls[configData.name].errors}" [configData]="control" [frmGroup]="getFormTableControls()[rowIndex]"></app-form-field>
                        </div>
                    </div>
                </div>
                <div class="col mat-cell" fxFlex="0 0 55px">
                    <button [hidden]="frmGroup.get(configData.name)['controls']['deleteButton'] === false || frmGroup.get(configData.name).status === 'DISABLED'" type="button" mat-icon-button (click)="deleteItem($event,rowIndex)" matTooltip="Delete {{configData.label}}">
                        <mat-icon color="accent">delete</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <div *ngIf="getFormTableControls().length === 0" class="row mat-footer-row">
            <div class="col mat-cell">No {{configData.label}} records added</div>
        </div>
        <!-- <div *ngIf="frmGroup.get(configData.name)['controls']['canAddItem'] === true" class="row mat-header-row" style="border-bottom: 0px;" [hidden]="frmGroup.status == 'DISABLED'"> -->
        <div *ngIf="frmGroup.get(configData.name)['controls']['canAddItem'] === true" class="row mat-header-row" style="border-bottom: 0px;" [hidden]="frmGroup.get(configData.name).status === 'DISABLED'">

            <div class="col mat-header-cell" style="font-size: 14px">
                <a href="#" (click)="addItem($event)">+ Add {{configData.label}}</a>
            </div>
        </div>
    </div>
</div>